export const CompanyMenuMainLogo = () => {
  return (
    <svg
      width="174"
      height="161"
      viewBox="0 0 174 161"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_19645_21145" fill="white">
        <path d="M0 3.99998C0 1.79084 1.79086 0 4 0H279C281.209 0 283 1.79086 283 4V722C283 724.209 281.209 726 279 726H4C1.79086 726 0 724.209 0 722V3.99998Z" />
      </mask>
      <path
        d="M0 3.99998C0 1.79084 1.79086 0 4 0H279C281.209 0 283 1.79086 283 4V722C283 724.209 281.209 726 279 726H4C1.79086 726 0 724.209 0 722V3.99998Z"
        fill="white"
      />
      <path
        d="M0 0H283H0M0 0M283 726H0H283M283 726M0 726V0V726M279 0C282.314 0 285 2.68629 285 6V720C285 723.314 282.314 726 279 726C280.105 726 281 724.209 281 722V4C281 1.79086 280.105 0 279 0Z"
        fill="#E2E6EB"
        mask="url(#path-1-inside-1_19645_21145)"
      />
      <g clipPath="url(#clip0_19645_21145)">
        <g clipPath="url(#clip1_19645_21145)">
          <path
            d="M18 32.8124C18 25.5928 18 21.9847 20.2441 19.744C22.4882 17.5035 26.0927 17.5 33.3124 17.5H34.6448C41.8609 17.5 45.469 17.5 47.7131 19.744C49.9572 21.9882 49.9537 25.5928 49.9537 32.8124V34.1448C49.9537 41.3609 49.9537 44.969 47.7131 47.2131C45.4725 49.4572 41.8609 49.4537 34.6448 49.4537H33.3124C26.0927 49.4537 22.4847 49.4537 20.2441 47.2131C18.0035 44.9725 18 41.3609 18 34.1448V32.8124Z"
            fill="#0077FF"
          />
          <path
            d="M49.9535 34.3663C49.9534 36.3198 49.9517 38.0051 49.9023 39.4682H42.0609C40.6293 39.4682 39.9135 39.4682 39.3666 39.1895C38.8856 38.9445 38.4946 38.5534 38.2495 38.0724C37.9709 37.5256 37.9709 36.8097 37.9709 35.3781V34.5952C37.9709 32.8056 37.9709 31.9109 37.6226 31.2273C37.3163 30.6261 36.8274 30.1373 36.2262 29.8309C35.5426 29.4826 34.6479 29.4826 32.8583 29.4826H32.0754C30.6438 29.4826 29.9279 29.4826 29.3811 29.204C28.9001 28.9589 28.5091 28.5679 28.264 28.0869C27.9854 27.54 27.9854 26.8242 27.9854 25.3926V17.552C29.504 17.5003 31.2624 17.5 33.3122 17.5H34.6446C41.8607 17.5 45.4688 17.5 47.713 19.744C49.93 21.9612 49.9533 25.5062 49.9535 32.5533C49.9535 32.6281 49.9535 32.7032 49.9535 32.7788V34.1448C49.9535 34.219 49.9535 34.2928 49.9535 34.3663Z"
            fill="#00D9ED"
          />
          <path
            d="M23.9912 41.2253C23.9912 42.4606 24.9926 43.462 26.228 43.462H31.1159C32.3512 43.462 33.3526 42.4606 33.3526 41.2253V36.3373C33.3526 35.102 32.3512 34.1006 31.1159 34.1006H26.228C24.9926 34.1006 23.9912 35.102 23.9912 36.3373V41.2253Z"
            fill="white"
          />
        </g>
        <path
          d="M65.3553 40.9604H69.1619L74.7522 25.6484H71.9897L67.5087 38.2672H67.0737L62.745 25.6484H59.939L65.3553 40.9604Z"
          fill="#1E1E1E"
        />
        <path
          d="M89.0471 40.9604L81.9994 33.0329L88.5033 25.6484H85.284L79.846 31.8818H79.2151V25.6484H76.6049V40.9604H79.2151V34.4012H79.8677L85.6103 40.9604H89.0471Z"
          fill="#1E1E1E"
        />
        <path
          d="M105.321 32.2735V25.8543H107.945V41.2472H105.321V34.6752H97.9956V41.2472H95.3716V25.8543H97.9956V32.2735H105.321Z"
          fill="#1E1E1E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M122.85 41.2472H119.767L115.699 35.5922H113.841V41.2472H111.217V25.8543H116.902C117.952 25.8543 118.892 26.0654 119.723 26.4875C120.554 26.895 121.203 27.47 121.669 28.2124C122.136 28.9402 122.369 29.7771 122.369 30.7232C122.369 31.8732 122.019 32.8702 121.319 33.7145C120.634 34.5442 119.716 35.1046 118.564 35.3957L122.85 41.2472ZM113.841 28.256V33.1905H116.902C117.718 33.1905 118.382 32.9649 118.892 32.5136C119.417 32.0478 119.679 31.451 119.679 30.7232C119.679 29.9955 119.417 29.4059 118.892 28.9547C118.382 28.4889 117.718 28.256 116.902 28.256H113.841Z"
          fill="#1E1E1E"
        />
        <path
          d="M133.665 41.2472H136.289V28.256H141.537V25.8543H128.417V28.256H133.665V41.2472Z"
          fill="#1E1E1E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M152.153 35.4394C152.153 35.6577 152.139 35.927 152.11 36.2472H142.969C143.086 37.1351 143.45 37.8484 144.063 38.3869C144.675 38.9109 145.455 39.173 146.402 39.173C147.044 39.173 147.62 39.0492 148.13 38.8018C148.655 38.5543 149.056 38.2195 149.333 37.7974L151.694 38.1904C151.286 39.2385 150.579 40.0463 149.573 40.614C148.582 41.1817 147.474 41.4655 146.249 41.4655C145.112 41.4655 144.092 41.2181 143.188 40.7232C142.299 40.2137 141.599 39.515 141.089 38.6271C140.593 37.7246 140.345 36.7057 140.345 35.5704C140.345 34.435 140.593 33.4234 141.089 32.5355C141.599 31.633 142.299 30.9343 143.188 30.4394C144.092 29.93 145.112 29.6752 146.249 29.6752C147.386 29.6752 148.4 29.93 149.289 30.4394C150.193 30.9343 150.892 31.6257 151.388 32.5136C151.898 33.387 152.153 34.3622 152.153 35.4394ZM146.249 31.8586C145.491 31.8586 144.828 32.0769 144.259 32.5136C143.705 32.9503 143.326 33.5398 143.122 34.2822H149.42C149.201 33.5544 148.808 32.9721 148.239 32.5355C147.685 32.0842 147.022 31.8586 146.249 31.8586Z"
          fill="#1E1E1E"
        />
        <path
          d="M161.285 41.2472H164.587L159.361 35.352L164.15 29.8936H161.154L157.349 34.304H156.737V25.8543H154.222V41.2472H156.737V36.7276H157.349L161.285 41.2472Z"
          fill="#1E1E1E"
        />
        <rect
          x="25"
          y="109"
          width="22"
          height="22"
          rx="7"
          fill="url(#paint0_linear_19645_21145)"
        />
        <rect
          x="67"
          y="109"
          width="195"
          height="22"
          rx="7"
          fill="url(#paint1_linear_19645_21145)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_19645_21145"
          x1="25"
          y1="120.19"
          x2="46.4844"
          y2="120.19"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.35" stopColor="#F4F6F8" />
          <stop offset="0.5" stopColor="#F4F6F8" stopOpacity="0.4" />
          <stop offset="0.75" stopColor="#F4F6F8" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_19645_21145"
          x1="67"
          y1="120.19"
          x2="257.43"
          y2="120.19"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.35" stopColor="#F4F6F8" />
          <stop offset="0.5" stopColor="#F4F6F8" stopOpacity="0.4" />
          <stop offset="0.75" stopColor="#F4F6F8" />
        </linearGradient>
        <clipPath id="clip0_19645_21145">
          <rect
            width="257"
            height="700"
            fill="white"
            transform="translate(13 13)"
          />
        </clipPath>
        <clipPath id="clip1_19645_21145">
          <rect
            width="31.9537"
            height="31.9537"
            fill="white"
            transform="translate(18 17.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
